export default "/public/app-main/static/image/59cd74ac1532ab9834fb825bab18c63c.png";